module.exports = __webpack_public_path__ + "img/arrow-left.e92b51c3.svg";